const workflowIdSelector = state => state.projectOverview.workflowId
const projectIdSelector = state => state.projectOverview.projectId
const redirectSelector = state => state.project.updateReview.redirect

export {
  workflowIdSelector,
  projectIdSelector,
  redirectSelector,
}
